import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faEdit } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';

//Api
import tipoCompensacao_api from '../../../../../api/tipoCompensacao_api';
import formulario_api from '../../../../../api/formulario_api';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateTipoCompensacao() {
    return {
        identificacao: "",
        orientacoes: "",
        status: "Ativo",
        replantio: "",
        formulario_Id: null
    }
}
export default function CadastroTipoCompensacao({ btnVoltar, id, editavel }) {
    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "replantio", required: true }),
    ])

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos de cadastro de tipo de compensação
    const [tipoCompensacao, setTipoCompensacao] = useState(initialStateTipoCompensacao());

    //Estado de controle dos formularios a serem exibidos no campo de formularios
    const [formularios, setFormularios] = useState([]);

    const { setLoading } = useAuth();

    //Função de onChange dos campos de cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _tipoCompensacao = {
            ...tipoCompensacao,
            [name]: value
        };
        if (name == "replantio" && value == "false")
            _tipoCompensacao.formulario_Id = null;

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_tipoCompensacao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setTipoCompensacao(_tipoCompensacao);
    }

    //Função que vai fazer o envio/ atualização dos dados
    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(tipoCompensacao, campos);
        setErrors(_errors[0])

        if (_errors[1].length > 0)
            return;

        //Realizando o cadastro/edição do documento
        const _tipoCompensacao = { ...tipoCompensacao };
        _tipoCompensacao.replantio = _tipoCompensacao.replantio == "true";

        setLoading(true);
        if (tipoCompensacao.id) {
            setLoading(true);
            tipoCompensacao_api.put(tipoCompensacao)
                .then(response => {
                    showMessage("Sucesso", "Tipo de compensação atualizado com sucesso!", "success", btnVoltar);
                })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            setLoading(true);
            tipoCompensacao_api.post(tipoCompensacao)
                .then(response => {
                    showMessage("Sucesso", "Tipo de compensação cadastrado com sucesso!", "success", btnVoltar);
                })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //Função que carrega os dados do tipo de compensação
    const loadTipoCompensacao = () => {
        setLoading(true);
        tipoCompensacao_api.getItem(id).then(response => {
            if (response.data.replantio) {
                response.data.formulario_Id = response.data.formulario_Id.toString();
                setCampos([...campos, objCampo({ name: "formulario_Id", required: true })]);
            }

            response.data.replantio = response.data.replantio.toString();
            setTipoCompensacao(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //onChange para o formulario de replantio
    const onChangeFormulario = (value, e) => {
        setTipoCompensacao({
            ...tipoCompensacao,
            [e.name]: value ? value.value : null,
        });
    }

    const loadFormularios = () => {
        setLoading(true);
        formulario_api.getList({ status: "Ativo", finalidade: "Vistoria" }).then(response => {
            response.data = response.data.map(value => {
                value.id = value.id.toString();
                return value;
            })
            setFormularios(response.data);
        }).catch(ex => showMessage("Erro", ex.message, "error", null))
            .finally(f => setLoading(false));
    }
    //Carrega os dados para atualização do tipo de compensação
    useEffect(() => {
        if (id)
            loadTipoCompensacao();

        loadFormularios();
    }, []);
    return (
        <>
            <Button onClick={btnVoltar} className='px-4'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar</Button>
            <MainCard>
                <h5 className='text-secondary'>Adicionar tipo de compensação</h5>
                <Row>
                    <Col md="12" lg={tipoCompensacao.replantio == "true" ? "6" : "5"}>
                        <TextField
                            label="* Identificação"
                            name={"identificacao"}
                            onChange={onChange}
                            value={tipoCompensacao.identificacao}
                            invalid={!!errors.identificacao}
                            maxLength={100}
                            disabled={!editavel} />
                    </Col>
                    {
                        tipoCompensacao.replantio == "true" &&
                        <Col md="12" lg="6">
                            <TextField
                                label={"* Formulário"}
                                name={"formulario_Id"}
                                onChange={onChangeFormulario}
                                type={"select"}
                                searchable
                                options={formularios.map(value => { return { value: value.id, label: value.identificacao } })}
                                value={
                                    formularios.filter(doc => doc.id === tipoCompensacao.formulario_Id).map(value => { return { value: value.id, label: value.identificacao } })
                                }
                                invalid={!!errors.formulario_Id}
                                disabled={!editavel}
                            />
                        </Col>
                    }
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Replantio"
                            name={"replantio"}
                            options={[
                                { label: "Sim", value: "true" },
                                { label: "Não", value: "false" }
                            ]}
                            onChange={(e) => {
                                const { value } = e.target;
                                if (value == "true") {
                                    setCampos([...campos, objCampo({ name: "formulario_Id", required: true })]);
                                } else {
                                    setCampos([...campos.filter(value => value.name != "formulario_Id")]);
                                }
                                onChange(e);
                            }}
                            value={tipoCompensacao.replantio}
                            invalid={!!errors.replantio}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="3">
                        <TextField
                            type={"radio"}
                            label="* Status"
                            name={"status"}
                            options={
                                [
                                    { label: "Ativo", value: "Ativo" },
                                    { value: "Inativo", label: "Inativo" }
                                ]
                            }
                            onChange={onChange}
                            value={tipoCompensacao.status}
                            invalid={!!errors.status}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="12">
                        <TextField
                            label="Orientações"
                            name={"orientacoes"}
                            type={"textarea"}
                            onChange={onChange}
                            value={tipoCompensacao.orientacoes}
                            invalid={!!errors.orientacoes}
                            maxLength={500}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mt-4'>
                        {editavel &&
                            <Button className='px-4' color={id ? 'warning text-white' : 'success'} onClick={onSubmit}>{id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}</Button>
                        }
                    </Col>
                </Row>
            </MainCard >
        </>
    )
}